export type TText = {
  value: string;
  link: string;
};
export interface INavigation {
  brand: TText;
  stores: TText;
  architects: TText;
  contact: TText;
  voxbox: TText;
  promotions: TText;
}
export enum ENavTransparency {
  BOTH_TRANSPARENT = 'BOTH_TRANSPARENT',
  BOTH_NOT_TRANSPARENT = 'BOTH_NOT_TRANSPARENT',
  DESKTOP_TRANSPARENT_MOBILE_NOT_TRANSPARENT = 'DESKTOP_TRANSPARENT_MOBILE_NOT_TRANSPARENT',
  DESKTOP_NOT_TRANSPARENT_MOBILE_TRANSPARENT = 'DESKTOP_NOT_TRANSPARENT_MOBILE_TRANSPARENT',
}
export type TNavFontColor = 'dark' | 'white' | 'auto';
export interface INavParams {
  navTransparency: ENavTransparency;
  fontColorVariant?: TNavFontColor;
  backgroundColor?: string;
  withBorder?: boolean;
}